import platform from 'platform';

type Platform = typeof platform;

let clientUserAgentCache: Platform;

export const userAgent = (): Platform => {
  if (typeof clientUserAgentCache !== 'undefined') {
    return clientUserAgentCache as Platform;
  }

  const rawUserAgent = navigator.userAgent;
  clientUserAgentCache = platform.parse(rawUserAgent);

  return clientUserAgentCache;
};
